import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import FullLayout from "../layouts/fullLayout";
import AuthContext from "utils/context/AuthContext";
import { savePostLoginRedirect } from "utils/postLoginRedirect";

// Email "Accept" deep link: logged out users go to login and come back here afterwards
const JobApplyRoute = ({ children }) => {
  const { isUserAuthenticated } = useContext(AuthContext);
  const location = useLocation();

  if (!isUserAuthenticated) {
    savePostLoginRedirect(`${location.pathname}${location.search}`);
    return <Navigate to="/login" replace />;
  }
  return <FullLayout>{children}</FullLayout>;
};

export default JobApplyRoute;
